import { useState,useEffect,useRef } from "react";
import { Col, Row } from "react-bootstrap";
import normatecaStore from "../../../stores/normatecaStore";
import { useNavigate } from "react-router-dom";
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";
import Ordena from "../Ordenamiento/Ordena";

export default function MenuSup(){
    const navigate= useNavigate();
    // store - zuntand
    const {documentos,setQuitaMatSub,menuSupMat,materiaSel,submateriaSel,setCambiaMenuSupMat,menuSupSub, indMateria} =
    normatecaStore((state) =>( { 
        documentos: state.documentos,
        setQuitaMatSub: state.setQuitaMatSub,
        menuSupMat: state.menuSupMat,
        materiaSel: state.materiaSel,
        submateriaSel: state.submateriaSel,
        setCambiaMenuSupMat: state.setCambiaMenuSupMat,
        menuSupSub:state.menuSupSub,
        indMateria: state.indMateria,
    })); 
    const mat= useRef(null);
    const sub= useRef(null);
    const [visMenuMat, setVisMenuMat]= useState(false);
    const [visMenuSub, setVisMenuSub]= useState(false);

    const cambiaMateria=(indice)=>{
        setCambiaMenuSupMat(indice).catch(null);
        visualizaMenuMat();
        
    }
    const cambiaContenido=(opcVis, indices)=>{
        visualizaMenuSub();
        navigate("/app/normateca/menu=" + opcVis + "_" + indMateria + "-" + indices);
    }
    const visualizaMenuMat=()=>{
        setVisMenuMat(!visMenuMat);//? false:true
    }
    const visualizaMenuSub=()=>{
        setVisMenuSub(!visMenuSub);//? false:true
    }
    const quitaSubmateria=()=>{
        setQuitaMatSub("s").catch(null);
    }
    const quitaMateria=()=>{
        setQuitaMatSub("m").catch(null);
    }
    useEffect(() => {
        document.addEventListener("click", clickOutsideMat, false);
        document.addEventListener("click", clickOutsideSub, false);
        return () => {
        document.removeEventListener("click", clickOutsideMat, false);
        document.removeEventListener("click", clickOutsideSub, false);
        };
    }, []);
    const clickOutsideMat = event => {
        if (mat.current && !mat.current.contains(event.target)) {
            setVisMenuMat(false);
        }
    };
    const clickOutsideSub = event => {
        if (sub.current && !sub.current.contains(event.target)) {
            setVisMenuSub(false);
        }
    };
    return(
        <Row className="divDocMat">
            <Col sm={2} className="display-flex margin-bottom-05 width-auto">
                <div className="color-blue2 whiteSpace-nowrap">Resultados encontrados:</div>
                <div className="divGralResult"><div className="divResult"><label className="resut">{documentos.length}</label></div>
                </div>
            </Col>
            <Col sm={2} className="width-auto margin-bottom-05">
                {/* Materia */}
                {materiaSel!=="Materia"?
                    <div className="display-flex matSelec">
                        <div className="padleft-05 padRight-05">{materiaSel}</div>
                        <div>
                            {submateriaSel==="Submateria"?
                                <a onClick={quitaMateria} ><span className="inegi-cruz-c vertAlign-mid"></span></a>
                            :
                                null
                            }
                        </div>
                    </div>
                :
                    <div className="menuSupMat width-25" ref={mat}>
                        <Accordion className="divAcoordionMenuSup">
                            <AccordionItem key={0} >
                                <AccordionHeader className="menuOrdena display-flex" onClick={visualizaMenuMat}>
                                    <div className="width-95">Materia </div> 
                                    <div className={visMenuMat? "inegi-nav-despa alignSelf-center color-blue padleft-05 color-blue":"inegi-nav-desp alignSelf-center color-blue padleft-05"}></div>
                                </AccordionHeader>
                                <AccordionBody className={visMenuMat? 'display-contents' : 'display-none'}>
                                    <div className="accordion-body divOpcOdena" key={"div1"} >
                                        <AccordionItem key={"aci"}>
                                            {menuSupMat.map((mat,index) => {
                                                return (
                                                    <div key={"mat" + index.toString()} className="accordion-body divOpcOrdenaItem"  onClick={()=>cambiaMateria(index)}>
                                                        {mat.nombre}
                                                    </div>
                                                );
                                            })}
                                    </AccordionItem>
                                    </div>
                                </AccordionBody>
                            </AccordionItem>
                        </Accordion>
                    </div>
                }
            </Col>
            <Col sm={2} className="width-30Mat margin-bottom-05">
                {/* submateria */}
                {submateriaSel!=="Submateria"?
                    <div className="display-flex matSelec">
                        <div className="padleft-05 padRight-05">{submateriaSel}</div>
                        <div> 
                            <a onClick={quitaSubmateria} ><span className="inegi-cruz-c vertAlign-mid"></span></a>
                        </div>
                    </div>
                :
                    materiaSel!=="Materia"?
                        <div className="menuSupMat width-35" ref={sub}>
                            <Accordion className="divAcoordionMenuSup">
                                <AccordionItem key={"sub0"} >
                                    <AccordionHeader className="menuOrdena display-flex" onClick={visualizaMenuSub}>
                                        <div className="width-95">Submateria </div> 
                                        <div className={visMenuSub? "inegi-nav-despa alignSelf-center color-blue padleft-05 color-blue":"inegi-nav-desp alignSelf-center color-blue padleft-05"}></div>
                                    </AccordionHeader>
                                    <AccordionBody className={visMenuSub? 'display-contents' : 'display-none'}>
                                        <div className="accordion-body divOpcOdena" key={"div1"} >
                                            <AccordionItem key={"aci"}>
                                                {menuSupSub.map((sub,index) => {
                                                    return (
                                                        <div key={"sub" + index.toString()} className="accordion-body divOpcOrdenaItem"  onClick={()=>cambiaContenido(sub.id, index)}>
                                                            {sub.nombre}
                                                        </div>
                                                    );
                                                })}
                                        </AccordionItem>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    :
                        null
                }
            </Col>
            <Col sm={1}>
                <Ordena opc="m"/>
            </Col>
        </Row>
    )
}